import { FuseLoadable } from '@fuse';

export const FaqConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/:organizacao/:empresa/faq/:id',
            component: FuseLoadable({
                loader: () => import('./FaqBasePage')
            })
        },
        // {
        //     path: '/faq',
        //     component: FuseLoadable({
        //         loader: () => import('./FaqBasePage')
        //     })
        // }
    ]
};
